<template>
  <div id="home" class="home mdc-container pt-5">
    <Animjs />
    <Hero />
    <DarkMode />
    <div class="d-none d-md-block">
      <PrivacySecurity />
      <Profiles />
      <NewsFeed />
      <Maps />
      <Favorites />
      <Search />
      <Messages />
      <Photos />
      <Radar />
      <SmartContracts />
      <Developers />
      <Faq />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import lazyLoadComponent from '@/utils/lazy-load-component'
import SkeletonBox from '@/components/SkeletonBox.vue'
import Animjs from '@/components/Animjs.vue'
import DarkMode from '@/components/DarkMode.vue'
import Hero from '@/components/Hero.vue'
// import PrivacySecurity from '@/components/PrivacySecurity.vue'
// import Profiles from '@/components/Profiles.vue'
// import NewsFeed from '@/components/NewsFeed.vue'
// import Maps from '@/components/Maps.vue'
// import Favorites from '@/components/Favorites.vue'
// import Search from '@/components/Search.vue'
// import Messages from '@/components/Messages.vue'
// import Photos from '@/components/Photos.vue'
// import Radar from '@/components/Radar.vue'
// import SmartContracts from '@/components/SmartContracts.vue'
// import Developers from '@/components/Developers.vue'
// import Footer from '@/components/Footer.vue'
const defaultOptions = {
  loading: SkeletonBox,
  loadingData: {
    props: {
      width: `100%`,
      height: `20em`
    }
  }
}

export default {
  name: 'Home',
  metaInfo() {
    return {
      title: this.$t('description') || 'Default',
      titleTemplate: 'Surfverse - %s',
      meta: [{ name: 'description', content: this.$t('description') }]
    }
  },
  components: {
    Animjs,
    DarkMode,
    Hero,
    PrivacySecurity: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "privacy-component" */ `@/components/PrivacySecurity.vue`
        )
    }),
    Profiles: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "profiles-component" */ `@/components/Profiles.vue`
        )
    }),
    NewsFeed: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "newsfeed-component" */ `@/components/NewsFeed.vue`
        )
    }),
    Maps: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(/* webpackChunkName: "maps-component" */ `@/components/Maps.vue`)
    }),
    Favorites: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "favorites-component" */ `@/components/Favorites.vue`
        )
    }),
    Search: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "search-component" */ `@/components/Search.vue`
        )
    }),
    Messages: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "messages-component" */ `@/components/Messages.vue`
        )
    }),
    Photos: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "photos-component" */ `@/components/Photos.vue`
        )
    }),
    Radar: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "radar-component" */ `@/components/Radar.vue`
        )
    }),
    SmartContracts: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "blockchain-component" */ `@/components/SmartContracts.vue`
        )
    }),
    Developers: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(
          /* webpackChunkName: "developers-component" */ `@/components/Developers.vue`
        )
    }),
    Faq: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () =>
        import(/* webpackChunkName: "faq-component" */ `@/components/Faq.vue`)
    })
  }
}
</script>
<i18n>
{
  "en": {
    "title": "Surfverse",
    "description": "Connect with founders and their Startups.",
    "mission": "Supporting future entrepeneurs to shape our world."
  },
  "ro": {
    "title": "Despre noi",
    "description": "Conectați-vă cu fondatori și startup-urile lor.",
    "mission": "Sprijinim viitorii antreprenori în călătoria lor de a remodela lumea."
  },
  "de": {
    "title": "About Us",
    "description": "Deutch in germana",
    "mission": "Sprijinim viitorii antreprenori în călătoria lor de a remodela lumea."
  }
}
</i18n>

<style>
.Section__backgroundMask {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: visible;
}
.Section__background {
  position: relative;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  -webkit-transform-origin: 100% 0;
  transform-origin: 100% 0;
  -webkit-transform: skewY(-6deg);
  transform: skewY(-6deg);
  background: #1b1b1b;
  overflow: hidden;
}
.Guides {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0 16px;
  pointer-events: none;
}
.Guides__container {
  display: grid;
  grid: 1fr / repeat(7, 1fr);
  position: relative;
  max-width: var(--layoutWidth);
  height: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
}
.Guides__guide {
  width: 1px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(var(--grid-cell-guide)),
    color-stop(50%, var(--grid-cell-guide)),
    color-stop(50%, transparent),
    to(transparent)
  );
  background: linear-gradient(
    180deg,
    var(--grid-cell-guide),
    var(--grid-cell-guide) 50%,
    transparent 0,
    transparent
  );
  background-size: 1px 8px;
}
.Guides__guide:first-of-type,
.Guides__guide:last-of-type {
  background: transparent;
}
.Guides__guide:last-of-type {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}
</style>
<style>
:root {
  --mdc-layout-grid-gutter-desktop: 10px;
}
article {
  background-color: #000;
}
.text-nav {
  font-family: Oswald;
  letter-spacing: 5px;
  font-weight: bold;
  /* font-size: 2.25vw; */
  font-size: clamp(16px, 4vw, 22px);
  color: #00a15f !important;
  text-transform: uppercase;
}
.text-title {
  color: #00a15f !important;
}
.demo-grid {
  min-width: 360px;
}
.mdc-image-list__image {
  left: 0;
  position: absolute;
  top: 0;
  display: block;
}
.footer-brand-cell {
  background: var(--grid-cell);
  height: 430px;
  min-height: 430px;
}
.footer-cell {
  background: var(--grid-cell);
  height: 100px;
  min-height: 100px;
}
.title-cell {
  background: var(--grid-cell);
  height: 100px;
  min-height: 100px;
}
.grid-cell {
  background: var(--grid-cell);
  height: 82.56vh;
  min-height: 800px;
}

.full-cell {
  min-height: 149px;
  max-height: 849px;
}
.figure[image='intro'] {
  position: relative;
  left: 50%;
  margin-left: -400px;
  bottom: -30px;
}
.mdc-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1440px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-x: hidden;
}
.pane-content {
  position: relative;
  display: flex;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 42px 50px;
  height: 100%;
  overflow: hidden;
}
figure[role='img'] {
  left: 50%;
  margin-left: -137px;
  position: absolute;
  bottom: 0;
}
figure[role='img-center'] {
  left: 50%;
  margin-left: -170px;
  position: absolute;
  top: 150px;
}
figure[role='img-left'] {
  position: absolute;
  bottom: inherit;
}
figure[role='img-right'] {
  right: 0;
  position: absolute;
  bottom: 0;
}
figure[role='img-full'] {
  position: absolute;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}
figure[image='feature1-item3'] {
  position: absolute;
  left: 50%;
  margin-left: -400px;
  bottom: -25%;
}
/* figure[image=feature1-item3] {
        position: relative;
        left: 50%;
        margin-left: -400px;
        bottom: -30px;
      } */
figure[image='feature1-item3-1'] {
  position: absolute;
  top: -17px;
  left: 115px;
}
figure[image='screen-feature1-item3'] {
  position: relative;
  width: 748px;
  height: 840px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(https://static.xx.fbcdn.net/rsrc.php/v3/yb/r/QijzV_Ciy0Q.png);
  left: 31.4%;
  z-index: 0;
  bottom: -5%;
}
figure[image='feature3-map'] {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin: 0;
  -webkit-clip-path: inset(0% 0% 0% 0);
  clip-path: inset(0% 0% 0% 0);
  z-index: 0;
  width: 100%;
}
.image-intro {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(https://static.xx.fbcdn.net/rsrc.php/v3/yb/r/QijzV_Ciy0Q.png);
}
figure[image='screen-feature1-item3'] {
  position: relative;
  width: 900px;
  height: 840px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(https://static.xx.fbcdn.net/rsrc.php/v3/yb/r/QijzV_Ciy0Q.png);
}
.screen-feature1-item3 {
  z-index: 9;
}
.image-feature2-item2 {
  width: 372px;
  height: 630px;
  background-size: 372px 630px;
  background-repeat: no-repeat;
  background-image: url(/src/images/feature1/2fa.png);
  margin-bottom: -60px;
}
.image-feature2-item2-1 {
  width: 320px;
  height: 550px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(/src/images/feature1/IPhone_11_Pro_Midnight_Green.png);
  margin-bottom: -60px;
}
/* .image-feature2-item1 {
  width: 100%;
  height: 100%;
  left: 0;
  background-size: 340px 591px;
  background-repeat: no-repeat;
  background-image: url(/src/images/feature2/signin-with-google.png);
  bottom: 60px;
} */

.sticky-container {
  top: 100px;
  right: 180px;
  position: absolute;
}

.content-wrapper {
  margin: 0;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
}
.map1 {
  -webkit-box-pack: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
}
.map2 {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.map3 {
  -webkit-box-pack: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
}
/* .section-privacy-security {
        margin-top: calc(50vh + 480px / 2 - 95px)
      } */
.text-shadow {
  text-shadow: rgb(255, 255, 255) 0px 0px 5px, rgb(255, 255, 255) 0px 0px 10px,
    #e91e63 0px 0px 20px, #e91e63 0px 0px 30px, #e91e63 0px 0px 40px,
    #e91e63 0px 0px 55px, #e91e63 0px 0px 75px;
}
.neon-flicker {
  animation: flicker 1.5s alternate;
  animation-iteration-count: 3;
}
/* Intro section */
._8iil {
  display: inline-block;
  height: 100%;
  top: 0;
  width: 100%;
  padding-top: 0 !important;
  padding: var(--mdc-layout-grid-margin-desktop, 24px);
}
._8ij2 {
  margin: 0 auto;
  max-width: 86%;
}
._8iih header,
._8iih footer,
._8iih section {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}
._8ry0 {
  align-items: center;
  display: grid;
  grid-column-gap: 40px;
  grid-row-gap: 0;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  margin-top: 40px;
}
.cd-app-screen::before {
  top: 0;
  left: 0;
  height: 40px;
  width: 100%;
  background: #1c1a1e;
  border-radius: 4px 4px 0 0;
  content: '';
  position: absolute;
}
.cd-app-screen::after {
  top: 14px;
  left: 31px;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  box-shadow: -12px 0px 0px #307eff, 12px 0px 0px #ffba30, 36px 0px 0px #ff3030,
    62px 0px 0px #00a15f;
  content: '';
  position: absolute;
}
.cd-app-screen {
  border-radius: 8px;
  box-shadow: 0 6px 52px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05);

  padding-top: 56.1%;
  position: relative;
  transform: translate3d(0, 0, 0);
  width: 100%;
}
.cd-app-screen img {
  left: 0;
  position: absolute;
  top: 40px;
}
._8iih img {
  border: 0;
  display: block;
}
._8iih img,
._8iih object,
._8iih embed {
  height: auto;
  max-width: 100%;
}
._8iih * {
  -webkit-font-smoothing: antialiased;
  text-decoration: none;
  text-rendering: optimizeLegibility;
  -webkit-user-select: none;
}
[data-scroll] {
  transition: all 2s;
  transition-delay: 0ms;
}
[data-scroll='in'] {
  opacity: 1;
}
[data-scroll='out'] {
  opacity: 0;
}

[data-scroll].image-feature1-item1-1 {
  transition: all 2000ms;
}
[data-scroll='in'].image-feature1-item1-1 {
  opacity: 1;
  transform: translateX(0);
  transition-delay: 2s;
}
[data-scroll='out'].image-feature1-item1-1 {
  opacity: 0;
  transform: translateX(372px);
}

[data-scroll].image-feature3-item1 {
  transition: all 2000ms;
}
[data-scroll='in'].image-feature3-item1 {
  opacity: 1;
  transform: translateX(0);
  transition-delay: 2s;
}
[data-scroll='out'].image-feature3-item1 {
  opacity: 1;
  transform: translateX(270px);
}

[data-scroll].image-feature3-item1-text {
  transition: all 2s;
}
[data-scroll='in'].image-feature3-item1-text {
  opacity: 1;
  transition-delay: 4s;
}
[data-scroll='out'].image-feature3-item1-text {
  opacity: 0;
}

[data-scroll='in'].place-cell:nth-child(2) {
  transition-delay: 250ms;
}
[data-scroll='in'].place-cell:nth-child(3) {
  transition-delay: 350ms;
}
[data-scroll='in'].place-cell:nth-child(4) {
  transition-delay: 450ms;
}
[data-scroll='in'].place-cell:nth-child(5) {
  transition-delay: 550ms;
}
[data-scroll='in'].place-cell:nth-child(6) {
  transition-delay: 650ms;
}
[data-scroll='in'].place-cell:nth-child(7) {
  transition-delay: 750ms;
}
[data-scroll='in'].place-cell:nth-child(8) {
  transition-delay: 850ms;
}
</style>
